import { ROUTE_STRING } from 'constants/RouteString';
import Detail from './Detail';
import { RoutePermittedRole } from 'constants/AppConst';
import AllowedAccess from '@tenant/core/AppPermission/AllowedAccess';
import { AuthorizePermission } from '@tenant/utility/constants/authorizePermission';

export const containerAppRoutes = [
  {
    permittedRole: RoutePermittedRole.User,
    path: [ROUTE_STRING.CONTAINER_APP.VIEW],
    element: (
      <AllowedAccess
        permissionIds={[AuthorizePermission.APP_INSTANCE_CONTAINER_READ]}
      >
        <Detail />
      </AllowedAccess>
    ),
  },
];
